import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import TextSearchField from './TextSearchField';

const DebouncedInput = ({
  value: initialValue,
  onChange,
  debounce = 500,
  includeForm = true,
  ...props
}) => {
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      onChange(value);
    }, debounce);

    return () => clearTimeout(timeout);
  }, [value]);

  return (
    <TextSearchField
      {...props}
      value={value}
      onChange={(e) => setValue(e?.target.value)}
      onKeyDown={(e) => setValue(e?.target.value)}
      onSubmit={(e) => setValue(e?.target.value)}
      onReset={() => setValue('')}
      includeForm={includeForm}
    />
  );
};
DebouncedInput.propTypes = {
  value: PropTypes.string,
  debounce: PropTypes.number,
  onChange: PropTypes.func,
  includeForm: PropTypes.bool,
};

export default DebouncedInput;
